export default "__VITE_ASSET__DVNwFX2i__"